import backend from '@common/backend';

const BASE = '/mentors';

export interface IGetMentorsQuery {
	search?: string;
	page?: number;
	limit?: number;
}

export const groupFromBE = (group: any) => (
	group ? {
			...group,
			service: group.service_id,
			service_template: group.service_template_id,
		} : group
	);

export const getMentors = async (query: IGetMentorsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createMentor = async (data: any) => backend.post(`${BASE}`, data);

export const getMentor = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeMentor = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveMentor = async (id: number, data: any) => backend.post(`${BASE}/${id}`, data);

export const getMentorGroups = async (id: number, query: any) => backend
	.get(`${BASE}/${id}/groups`, { params: query })
	.then((groups: any) => groups.map(groupFromBE));
